import React from 'react';

// Styled Components
import { StyledPaper, HeaderContainer, AppDetails, TitleText, MessageText, StyledNotificationsIcon } from './styles';

const NotificationPreview = ({ author, message }) => (
  <StyledPaper>
    <HeaderContainer>
      <StyledNotificationsIcon />
      <AppDetails>Puntu • agora</AppDetails>
    </HeaderContainer>
    <TitleText>{author} diz:</TitleText>
    <MessageText>{message || 'Exemplo de mensagem'}</MessageText>
  </StyledPaper>
);

export default NotificationPreview;
